var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4999 15.8333C12.5 16.2538 12.3412 16.6588 12.0553 16.9671C11.7694 17.2754 11.3775 17.4643 10.9582 17.4958L10.8332 17.5H9.16654C8.74606 17.5001 8.34107 17.3413 8.03275 17.0554C7.72443 16.7695 7.53558 16.3776 7.50404 15.9583L7.49987 15.8333H12.4999ZM9.99987 1.66663C11.5124 1.6666 12.9657 2.25404 14.0534 3.30502C15.1411 4.35601 15.778 5.78837 15.8299 7.29996L15.8332 7.49996V10.6366L17.3515 13.6733C17.4178 13.8058 17.451 13.9524 17.4482 14.1005C17.4454 14.2486 17.4068 14.3939 17.3356 14.5238C17.2644 14.6537 17.1628 14.7644 17.0394 14.8465C16.9161 14.9285 16.7747 14.9795 16.6274 14.995L16.5315 15H3.46821C3.32001 15 3.17401 14.9641 3.04272 14.8954C2.91144 14.8266 2.79877 14.7271 2.71439 14.6053C2.63 14.4834 2.57641 14.343 2.55821 14.1959C2.54001 14.0488 2.55774 13.8995 2.60987 13.7608L2.64821 13.6733L4.16654 10.6366V7.49996C4.16654 5.95286 4.78112 4.46913 5.87508 3.37517C6.96905 2.28121 8.45278 1.66663 9.99987 1.66663Z",
    fill: "#4CAF50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notification-icon.3215b4439193e4ccd8157bfd066b8cee.svg";
export { ForwardRef as ReactComponent };